import { render, staticRenderFns } from "./PartnerReportDetailInfoLeasingTimeLineElement.vue?vue&type=template&id=0996b6bf&"
import script from "./PartnerReportDetailInfoLeasingTimeLineElement.vue?vue&type=script&lang=ts&"
export * from "./PartnerReportDetailInfoLeasingTimeLineElement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VDataTable})
